'use client';

import { FundPageContent } from '../components/FundPageContent';

export default function OpportunitiesPage() {
  return <FundPageContent marketplaceTab="opportunities" />;
}
